module.exports = __webpack_public_path__ + "static/img/win_record.d1ecc8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/win_record.png
// module id = gYDP
// module chunks = 0